import { useTranslation } from 'react-i18next';

import { IntegrationCard } from '~features/integrations/IntegrationCard';

import { useConnectFacebook } from '../model/useConnectFacebook';
import { useDisconnectFacebook } from '../model/useDisconnectFacebook';
import { useGetFacebookPages } from '../model/useGetFacebookPages';
import { FacebookLogo } from './FacebookLogo';

type FacebookCardProps = {
  pharmacyId: string;
};

export function FacebookCard({ pharmacyId }: FacebookCardProps) {
  const { t } = useTranslation();

  const { pages } = useGetFacebookPages(pharmacyId);
  const {
    mutate: connect,
    isPending: isConnecting,
    cancelCount,
  } = useConnectFacebook(pharmacyId);
  const { mutate: disconnect, isPending: isDisconnecting } =
    useDisconnectFacebook(pharmacyId);

  const isConnected = (pages?.length ?? 0) > 0;

  const isPending = isConnecting || isDisconnecting;

  const handleToggle = () => {
    if (isPending) {
      return;
    }
    if (isConnected) {
      disconnect();
    } else {
      connect();
    }
  };

  return (
    <IntegrationCard
      identity={{
        logo: <FacebookLogo />,
        name: 'Facebook',
      }}
      pending={{
        isPending,
        label: isConnecting ? t('integrations facebook connecting') : undefined,
      }}
      switchProps={{
        key: cancelCount.current,
        checked: isConnected,
        onCheckedChange: handleToggle,
      }}
    />
  );
}
